export default {
  message: {
    hello: 'hello world'
  }
}